import React, {memo} from 'react';
import {observer} from "mobx-react-lite";
import classNames from "classnames";
import {useRootStore, useUserState} from "@stores/AppStateContext";

import type {ItemModelType} from "../../../stores/WorkspaceStore";

import {hasOtherActiveUsers} from "../../../utils/userHelper";
import {getDocPath} from "../../../stores/ActivityProvider";

import {screenSizeProvider} from "../../../stores/ScreenSizeProvider";

import "../../components/ActiveUserStatusDot/ActiveUserStatusDot.css";

export interface ItemLineActiveProps {
    item: ItemModelType;
}

export const ItemLineActive = memo(observer((
    {
        item,
    }: ItemLineActiveProps
) => {
    const rootStore = useRootStore();
    const userState = useUserState();
    const isMobile = screenSizeProvider.view !== 'desktop';
    const _isReadOnly = userState!.isCurrentUserReadOnly;
    const activity = userState!.activityProvider.activity;
    const activeUserSetOnPage = activity.get(getDocPath(rootStore.view.workspace!.id, item.id));
    const isActive = activeUserSetOnPage && hasOtherActiveUsers(activeUserSetOnPage, userState!.currentUserId!);

    return (
        !isMobile
            ? (
                <span
                    className={classNames({
                        "ItemLine__active-users-badge": true,
                        "ActiveUserStatusDot": true,
                        "ActiveUserStatusDot--no-ring": true,
                        "ItemLine__active-users-badge--isVisible": isActive,
                        "ItemLine__active-users-badge--VisibleInHover": _isReadOnly && isActive,
                    })}
                    aria-hidden="true"
                />
            )
            : null
    );
}));
